module.exports = __webpack_public_path__ + "static/media/bg10.3be5ab88.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/contents/editorPreview/layout/components/Layout/bg/bg10.jpg
// module id = 3307
// module chunks = 0